import { Platform } from 'react-native';
import * as FileSystem from 'expo-file-system';

export async function uriToBase64(uri: string): Promise<string> {
  if (Platform.OS === 'web') {
    // Web: fetch the image and convert to base64
    const response = await fetch(uri);
    const blob = await response.blob();
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result as string);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } else {
    // Native: use expo-file-system
    const base64 = await FileSystem.readAsStringAsync(uri, {
      encoding: 'base64',
    });
    return `data:image/jpeg;base64,${base64}`;
  }
}
